import React, { Component } from "react";
import { formatoSeparadorMilesValue } from "../../generico/utils/FormatoInput";
import DataTable from "react-data-table-component";
import MensajeUsuario from "../../generico/MensajeUsuario";
import { trackPromise } from "react-promise-tracker";
import ActividadesEducacionService from "../../../services/pagos/ActividadesEducacionService";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowLeft, faArrowRight} from "@fortawesome/free-solid-svg-icons";
import $ from "jquery";
export default class EducacionPaso1 extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  getInitialState = () => ({
    listaEducacion: [],
    itemSelected: { value: "-1", label: "--Seleccione--" },
  });

  resetState = () => {
    this.setState(this.getInitialState());
  };

  initData = () => {
    this.resetState();
    this.getActividades();
    this.continuar.disabled = true;
  };
  getActividades() {
    trackPromise(
      ActividadesEducacionService.getActividades().then((response) => {
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);
        if (jData.codigoRetorno === "0") {
          this.setState({ listaEducacion: jData.resultados });
        } else {
          this.setState({
            mensaje: jData.mensajeRetorno,
          });
        }
      })
    );
  }

  componentDidMount() {
    this.initData();
  }

  getListaEducacion() {
    var respuesta = [];
    const { listaEducacion } = this.state;
    for (var i = 0; i < listaEducacion.length; i++) {
      
     
      respuesta.push({
        id: listaEducacion[i].actividad.trim(),
        nro: listaEducacion[i].actividad.trim(),
        nombre: listaEducacion[i].descripcion.trim(),
        moneda: listaEducacion[i].moneda,
        costo: formatoSeparadorMilesValue(listaEducacion[i].costo),
      });
    }

    return respuesta;
  }

  getColumn() {
    return [
      {
        name: "Nro. Actividad",
        selector: row => row.nro,
      },
      {
        name: "Nombre Actividad",
        selector: row => row.nombre,
      },
      {
        name: "Moneda",
        selector: row => row.moneda,
      },
      {
        name: "Costo",
        selector: row => row.costo,
      },
      {
        cell: (row) => (
          <input
            ref={() => this.grupoSel}
            id={"radio_" + row.id}
            type="radio"
            key={row.id}
            type="radio"
            name="rowRadio"
            value={row.id}
            onClick={this.selActividadEvt}
          ></input>
        ),
        width: "50px",
      },
    ];
  }

  selActividadEvt = (e) => {
   
    this.actividadSele = e.currentTarget;
    this.enableNext();
  };
  enableNext() {
    if (this.actividadSele !== undefined) {
      this.continuar.disabled = false;
    } else {
      this.continuar.disabled = true;
    }

    this.checkGrilla();
  }

  checkGrilla() {
    if (this.actividadSele !== undefined) {
      $("#" + this.actividadSele.id).prop("checked", true);
    }
  }
  seleccionarFila(row) {
   
    //pintarFilaSeleccionada("row-" + row.id)
     
    var radio = document.getElementById("radio_" + row.id);
    radio.checked = true;
    row.value= row.id;
    radio.click(this.selActividadEvt);
     
    
 
  }
  getActividadFull(array, id) {
  
    var foundItems = $.grep(array, function (v) {
      var compos = v.actividad;
      return compos.trim() === id.toString();
    });
    return foundItems;
  }
  render() {
    return (
      <div>
        <div className="row">
          <div className="steps clearfix">
            <ul role="tablist">
              <li role="tab" className="current">
                <span>
                  <div className="title">
                    <span className="title_text current">
                      Selección de Actividades
                    </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text current">Datos de Pago</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Datos de Verificación</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <label className="input-label-bold">
              Seleccione la Actividad a la que Desea Inscribirse *
            </label>
            <DataTable
              noHeader={true}
              pagination={true}
              columns={this.getColumn()}
              data={this.getListaEducacion()}
              dense={true}
              pagination={false}
              noDataComponent="no hay actividades para mostrar"
              striped={true}
              onRowClicked={(e) => this.seleccionarFila(e)}
              pointerOnHover
              
            />
          </div>
        </div>

        <hr />

        <div className="row">
          <div className="col-lg-10 col-md-8">
              <label className="input-label-bold-obligatorio">
                (*) Campos Obligatorios
                <br />
              </label>
          </div>
          <div className="col-lg-2 col-md-4">
                <button
                ref={(button) => (this.continuar = button)}
                disabled={this.state.disableSgte}
                className="btn btn-cu-primary"
                onClick={() => {
                  var itemFull = this.getActividadFull(
                    this.state.listaEducacion,
                    this.actividadSele.value
                  );
                  this.props.returnDataPaso1(itemFull);
                  this.nextStep.click();
                }}
              >
                {" "}
                Continuar <FontAwesomeIcon icon={faArrowRight} />
              </button>
              <button
                hidden
                ref={(a) => (this.nextStep = a)}
                className="btn btn-cu-primary"
                onClick={this.props.nextStep}
              />
        
          </div>
        </div>
      </div>
    );
  }
}
